import React, { useState, useContext, useEffect, useMemo } from 'react';
import Alert from '@mui/material/Alert';
import InputBox from '../../atomic/inputbox/InputBox';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import AtomicButton from '../../atomic/button/AtomicButton';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import { StoreHeaderDataContext } from '../../context-api/StoreHeaderDataProvider';
import { SignUpInfoDataContext } from '../../context-api/SignUpInfoDataProvider';
import './LoginForm.scss';
import {
  emailRegex,
  passwordRegex,
  API_NETWORK_ERROR,
  LOGIN_PAGE_API_ERROR,
  localStorageKeys,
} from '../../global/constants';
import { useNavigate } from 'react-router-dom';
import './LoginForm.scss';
import { isMobile, isIpad } from '../../global/ScreenSizeHelper';
import responseErrorMapping from './../../global/error.response.mapping';
import AlertDialog from '../../atomic/Dialog/Dialog';
import { Error404 } from '../Error404/Error404';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';
import { OnTheMenuDataContext } from '../../context-api/OnTheMenuDataProvider';
import { useNativeNotificationFields } from '../../utils/reactNativeBridge';

const clientId = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;

const LoginForm = () => {
  const navigate = useNavigate();
  const nativeNotificationFields = useNativeNotificationFields();
  const { loginData, onLogin, setIsLoggedIn, customerInfoData, onLogout, fingerPrint } =
    useContext(LoginDataContext);
  const { kitchensByZipcodeResponse } = useContext(StoreHeaderDataContext);
  const { generateOtpAPIHandler, setAccountType } = useContext(SignUpInfoDataContext);
  const { oneTimeMeal, setOneTimeMeal, oneTimeMealPrice, setOneTimeMealPrice } =
    useContext(OnTheMenuDataContext);

  const [email, setEmail] = useState(undefined);
  const [password, setPassword] = useState(undefined);
  const [isEmailFormatValid, setEmailFormatValid] = useState(true);
  const [isPassowrdFormatValid, setPasswordFormatValid] = useState(true);
  const [open, setOpen] = useState(false);
  const [displayText, setdisplayText] = useState('');
  const [showAgreeButton, setshowAgreeButton] = useState(true);
  const [showDisagreeButton, setshowDisagreeButton] = useState(true);
  const [inActiveByAdmin, setInActiveByAdmin] = useState(false);
  const [kitchenApiFailed, setKitchenApiFailed] = useState(false);
  const { ZIP_CODE, KITCHEN_NAMES } = localStorageKeys;
  const localStorageZipcode = () => (localStorage.getItem(ZIP_CODE) ? true : '');
  const localStorageKitchenNames = () => (localStorage.getItem(KITCHEN_NAMES) ? true : '');

  const { success, loading, data, errorMessage } = loginData;
  const showError = success;
  const {
    success: checkSuccess,
    loading: checkLoading,
    data: checkData,
    errorMessage: checkMessage,
    noKitchensFound,
  } = customerInfoData;
  const { success: SuccessChk, totalKitchens, message, isloading } = kitchensByZipcodeResponse;
  const custInfoData = checkData?.data || [];
  const userAcctStatus = custInfoData?.user_Info?.reason_status;
  const triggerLoader = loading || checkLoading || isloading;

  const RedirectToSignup = () => {
    setAccountType('');
    navigate('/signup');
  };
  const RedirectToForgotPassword = () => navigate('/forgotpassword');
  const RedirectToDeliveryaddressPage = () => navigate('/customeraccount/deliveryaddress');
  const RedirectToCreditCardPage = () => navigate('/customeraccount/cards');
  const RedirectToVerifyEmailPage = () => navigate('/emailverifydirect'); // This dedicated for logged in users to verify email
  const RedirectToStoreList = async () => navigate('/onthemenu');
  const RedirectToLogin = () => navigate('/login');
  const triggerLogout = async () => await onLogout();

  const AfterSuccessLogin = (loginResponseData) => {
    const { loginResponse, customerInfoResponse } = loginResponseData;
    const { success, CustomMessage } = loginResponse?.data;
    const {
      success: checkSuccess,
      user_Info,
      delivery_address,
    } = customerInfoResponse?.custData?.data || [];
    const { success: SuccessChk, totalKitchens } = customerInfoResponse?.zipCodeData?.data;
    const userAcctStatus = user_Info?.reason_status;
    const UserAccountType = user_Info?.account_type;

    // Successful login
    if (success === true && checkSuccess === true && SuccessChk === true) {
      // Removing oneTimeMeal if its subscription account
      if (UserAccountType === 'Subscription' && oneTimeMeal) {
        setOneTimeMeal(false);
        setOneTimeMealPrice(0);
      }

      // Account status Inactive by admin
      if (userAcctStatus === 'Inactive by admin') {
        triggerLogout();
        setInActiveByAdmin(true);
        setKitchenApiFailed(false);
      }

      if (userAcctStatus !== 'Inactive by admin' && totalKitchens > 0) {
        if (localStorageZipcode() !== true && localStorageKitchenNames() !== true) {
          triggerLogout();
          setKitchenApiFailed(true);
          RedirectToLogin();
        } else if (user_Info?.email_verified_status === 0) {
          generateOtpAPIHandler(email);
          RedirectToVerifyEmailPage();
        } else if (delivery_address.length <= 0) {
          RedirectToDeliveryaddressPage();
        } else if (userAcctStatus === 'Card decline' || userAcctStatus === 'Card adding pending') {
          RedirectToCreditCardPage();

          // Successful login with no issues
        } else if (userAcctStatus === 'Active' || userAcctStatus === 'Customer unsubscribed') {
          console.log('------LOGGED IN SUCCESSFULLY');
          RedirectToStoreList();
        }
        setIsLoggedIn(true);
      }
    }
  };

  const onSubmitHandler = async () => {
    const payload = { email, password, finger_print: fingerPrint, ...nativeNotificationFields };
    const isEmailValid = emailRegex.test(email);
    const isPasswordValid = passwordRegex.test(password);

    setEmailFormatValid(isEmailValid);
    setPasswordFormatValid(isPasswordValid);
    setKitchenApiFailed(false);
    setInActiveByAdmin(false);

    // Below if block should be if( isEmailValid && isPasswordValid ),update before going production to bleow block
    if (isEmailValid) {
      const loginResponseData = await onLogin(payload);

      if (loginResponseData) {
        AfterSuccessLogin(loginResponseData);
      }
    }
  };

  const OnGmailsuccess = async (token) => {
    const decodedToken = jwt_decode(token);
    const { email, family_name, given_name, picture } = decodedToken;

    const Payload = {
      email: email,
      auth_token: token,
    };

    const loginResponseData = await onLogin(Payload);

    if (loginResponseData) {
      AfterSuccessLogin(loginResponseData);
    }
  };

  const responseFacebook = (response) => {
    console.log('Facebook User:', response);
  };

  useEffect(() => {
    //Missing zipcode and kitchen in local storage
    if (
      totalKitchens > 0 &&
      localStorageZipcode() !== true &&
      localStorageKitchenNames() !== true
    ) {
      // triggerLogout()
      setKitchenApiFailed(true);
      console.log('------Missing zipcode and kitchen in local storage');
    }

    // When token or refresh token is not passed in payload to onCustomerInformationApiHandler have to logout user
    if (checkSuccess === false && checkMessage === 'Token & Refresh Token missing') {
      triggerLogout();
      RedirectToLogin();
    }
  }, [customerInfoData, totalKitchens]);

  if (
    (success === false && errorMessage === API_NETWORK_ERROR) ||
    (checkSuccess === false && checkMessage === API_NETWORK_ERROR) ||
    (SuccessChk === false && message === API_NETWORK_ERROR)
  ) {
    return <Error404 />;
  }

  const onChangeHandler = (event) => {
    event.preventDefault();
    const value = event.target.value;
    const targetName = event.target.name;

    if (targetName === 'email') {
      setEmail(value);
    }
    if (targetName === 'password') {
      setPassword(value);
    }
  };

  const loginButtonStyle = {
    backgroundColor: '#181436',
    width: isMobile ? '300px' : '100%',
    marginTop: '15px',
    marginBottom: '15px',
  };

  const isInvalidFormat = !isEmailFormatValid || !isPassowrdFormatValid;
  const showAlert = showError || isInvalidFormat;

  const containerClass = isIpad ? 'login-container-ipad' : 'login-container';
  if (isMobile) {
    return (
      <div className='login-container-mobile'>
        <div className='login-form-mobile'>
          <div>
            {kitchenApiFailed ? (
              <SentimentVeryDissatisfiedIcon sx={{ color: 'black', fontSize: '60px' }} />
            ) : (
              <InsertEmoticonIcon sx={{ color: 'black', fontSize: '60px' }} />
            )}
          </div>

          <div className='login-form-title-mobile'>Welcome back</div>
          {kitchenApiFailed && (
            <Alert
              severity='error'
              sx={{
                backgroundColor: 'lightpink',
                width: '100%',
                border: 'solid 1px red',
                marginBottom: '5px',
                color: 'darkred',
              }}
            >
              {<div>{LOGIN_PAGE_API_ERROR}</div>}
            </Alert>
          )}

          {(showAlert || inActiveByAdmin) && (
            <Alert
              severity='error'
              sx={{
                backgroundColor: 'white',
                width: '100%',
                border: 'solid 1px red',
                marginBottom: '5px',
                color: '#EE6969',
              }}
            >
              {isInvalidFormat ? (
                'Invalid Email or Password Format'
              ) : (
                <div>{responseErrorMapping(errorMessage)}</div>
              )}
              {inActiveByAdmin && <div>{responseErrorMapping(userAcctStatus)}</div>}
            </Alert>
          )}

          <InputBox
            type='email'
            label='Email'
            size='small'
            sx={{ width: '300px', height: 'auto', margin: '5px' }}
            name='email'
            value={email}
            inputErrorMsg=''
            error={showError || !isEmailFormatValid}
            onChange={onChangeHandler}
          />
          <InputBox
            type='password'
            label='Password'
            size='small'
            sx={{ width: '300px', height: 'auto', marginTop: '10px' }}
            name='password'
            value={password}
            inputErrorMsg=''
            error={showError || !isEmailFormatValid}
            onChange={onChangeHandler}
          />
          <AtomicButton
            loading={triggerLoader}
            disabled={triggerLoader}
            handleSubmit={onSubmitHandler}
            label='LOGIN'
            loadingButtonStyle={{}}
            style={loginButtonStyle}
          />
          <div className='login-optional-links-mobile'>
            <div>
              {' '}
              Don't have an account ? &nbsp;
              <span onClick={RedirectToSignup}>Sign Up</span>
            </div>
            <div style={{ marginTop: '5px' }}>
              {' '}
              Need help logging in ? &nbsp;
              <span onClick={RedirectToForgotPassword}>Forgot Password</span>
            </div>
            <div
              style={{ display: 'flex', flexDirection: 'row', margin: '10px', marginTop: '20px' }}
            >
              <hr width={'160px'} size='1' color='black' />
              <div style={{ fontSize: '14px', color: 'black', margin: '0px 5px 0px 5px' }}>OR</div>
              <hr width={'160px'} size='1' color='black' />
            </div>

            <GoogleOAuthProvider clientId={clientId}>
              <GoogleLogin
                size='large'
                width='300px'
                theme='outline'
                logo_alignment='center'
                onSuccess={(credentialResponse) => {
                  if (credentialResponse?.credential) {
                    console.log(credentialResponse?.credential);
                    OnGmailsuccess(credentialResponse?.credential);
                  }
                }}
                onError={() => {
                  console.log('Login Failed');
                }}
                click_listener={() => {}}
              />
            </GoogleOAuthProvider>

            <AtomicButton
              label={'Continue with Facebook'}
              disabled={false}
              style={{
                fontFamily: 'Helvetica, sans-serif',
                fontWeight: 700,
                color: '#2374f2',
                width: '300px',
                // text-transform: uppercase;
                // transition: background-color .3s, border-color .3s;
                backgroundColor: 'white',
                border: '1px solid #2374f2',
                borderRadius: '5px',
                marginTop: '10px',
              }}
              handleSubmit={() => {
                console.log('---facebook btn clicked');
              }}
              startIcon={''}
            />
          </div>
        </div>
        <AlertDialog
          isLoading={false}
          open={open}
          setOpen={setOpen}
          onAgree={null}
          onDisagree={null}
          displayText={displayText}
          showAgreeButton={showAgreeButton}
          showDisagreeButton={showDisagreeButton}
        />
      </div>
    );
  }

  return (
    <div className={containerClass}>
      <div className={isIpad ? 'login-form-ipad' : 'login-form'}>
        <div style={{ marginRight: '15px', marginBottom: '5px' }}>
          {kitchenApiFailed ? (
            <SentimentVeryDissatisfiedIcon sx={{ color: 'black', fontSize: '40px' }} />
          ) : (
            <InsertEmoticonIcon sx={{ color: 'black', fontSize: '40px' }} />
          )}
        </div>

        <div className={isIpad ? 'login-form-title-ipad' : 'login-form-title'}>Welcome back</div>
        {kitchenApiFailed && (
          <Alert
            severity='error'
            sx={{
              width: '100%',
              backgroundColor: 'lightpink',
              color: 'darkred',
              marginBottom: '5px',
            }}
          >
            {<div>{LOGIN_PAGE_API_ERROR}</div>}
          </Alert>
        )}

        {(showAlert || inActiveByAdmin) && (
          <Alert
            severity='error'
            sx={{ width: '100%', border: 'solid 1px red', marginBottom: '5px', color: '#EE6969' }}
          >
            {isInvalidFormat ? (
              'Invalid Email or Password Format'
            ) : (
              <div>{responseErrorMapping(errorMessage)}</div>
            )}
            {inActiveByAdmin && <div>{responseErrorMapping(userAcctStatus)}</div>}
          </Alert>
        )}
        <InputBox
          type='email'
          label='Email'
          size='small'
          sx={{ width: '100%', height: 'auto', margin: '6px 0px 5px 0px' }}
          name='email'
          value={email}
          inputErrorMsg=''
          error={showError || !isEmailFormatValid}
          onChange={onChangeHandler}
        />

        <InputBox
          type='password'
          label='Password'
          size='small'
          sx={{ width: '100%', height: 'auto', margin: '6px 0px 5px 0px' }}
          name='password'
          value={password}
          error={showError || !isPassowrdFormatValid}
          onChange={onChangeHandler}
        />
        <AtomicButton
          loading={triggerLoader}
          disabled={triggerLoader}
          handleSubmit={onSubmitHandler}
          label='LOGIN'
          loadingButtonStyle={{}}
          style={loginButtonStyle}
        />
        <div className={isIpad ? 'login-optional-links-ipad' : 'login-optional-links'}>
          <div>
            {' '}
            Don't have an account? &nbsp;
            <span onClick={RedirectToSignup}>Sign Up</span>
          </div>
          <span onClick={RedirectToForgotPassword}>Forgot Password</span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', margin: '10px', marginTop: '20px' }}>
          <hr width='150px' size='1' color='#d3d3d3' />
          <div style={{ color: 'gray', fontSize: '14px' }}>OR</div>
          <hr width='150px' size='1' color='#d3d3d3' />
        </div>

        <GoogleOAuthProvider clientId={clientId}>
          <GoogleLogin
            size='large'
            width={isIpad ? '340px' : '330px'}
            theme='outline'
            logo_alignment='center'
            onSuccess={(credentialResponse) => {
              if (credentialResponse?.credential) {
                console.log(credentialResponse?.credential);
                OnGmailsuccess(credentialResponse?.credential);
              }
            }}
            onError={() => {
              console.log('Login Failed');
            }}
            click_listener={() => {}}
          />
        </GoogleOAuthProvider>

        <AtomicButton
          label={'Continue with Facebook'}
          disabled={false}
          style={{
            fontFamily: 'Helvetica, sans-serif',
            fontWeight: 700,
            color: '#2374f2',
            width: isIpad ? '340px' : '340px',
            // text-transform: uppercase;
            // transition: background-color .3s, border-color .3s;
            backgroundColor: 'white',
            border: '1px solid #2374f2',
            // padding: '10px',
            borderRadius: '5px',
            marginTop: '10px',
          }}
          handleSubmit={() => {
            console.log('---facebook btn clicked 1');
          }}
          startIcon={''}
        />
      </div>

      <AlertDialog
        isLoading={false}
        open={open}
        setOpen={setOpen}
        onAgree={null}
        onDisagree={null}
        displayText={displayText}
        showAgreeButton={showAgreeButton}
        showDisagreeButton={showDisagreeButton}
      />
    </div>
  );
};

export default LoginForm;
